import React from 'react';
import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

const StyledLoading = ({ minHeight = '30vh', color = null, ...props }) => {
  return (
    <StyledLoadingContainer
    color={color}
      className="flex-center justify-content-center"
      style={{ minHeight }}
    >
      <Spinner animation="border" {...props} />
    </StyledLoadingContainer>
  );
};
const StyledLoadingContainer = styled.div`
  min-height: ${({ minHeight }) => minHeight};
  color: ${({ theme , color }) => color ? color : theme?.primary};
`;

export default StyledLoading;
